import axios from'src/utils/axios';
import { URLS } from 'src/utils/url';

class DeviceTypeService {

	create(params) {
		return alert("da sviluppare");
	}

	read() {
		return alert("da sviluppare");
	}

	update() {
		return alert("da sviluppare");
	}

	delete() {
		return alert("da sviluppare");
	}

	search(params) {
		return axios.get(URLS.CATALOG.DEVICE_TYPES, { params: params });
	}
}

const deviceTypeService = new DeviceTypeService();

export default deviceTypeService;